import React, { useState } from 'react';
import Accordion from './Accordion';
import styles from './Accordion.module.css';

const AccordionGroup = ({ accordions, className }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (accordions.length > 0) {
    return (
      <div className={`${styles.accordionGroup}${className ? ` ${className}` : ''}`}>
        {accordions.map((accordion, index) => (
          <Accordion
            className={styles.accordionWrapper}
            key={index}
            title={accordion.title}
            content={accordion.content}
            isOpen={openIndex === index}
            onClick={() => toggleAccordion(index)}
          />
        ))}
      </div>
    );
  }
  return null;
};

export default AccordionGroup;
